export default "__VITE_ASSET__Co1KBAFl__"